import { Redirect, useLocalSearchParams } from 'expo-router'
import ScreenView from '~/components/layout/ScreenView'
import { LeadDetailView } from '~/components/leads/LeadDetailView'

export default function PublicLeadPage() {
  const { leadId } = useLocalSearchParams<{ leadId: string }>()

  if (!leadId) {
    return <Redirect href="/" />
  }

  return (
    <ScreenView>
      <LeadDetailView key={leadId} leadId={leadId} initialView={undefined} />
    </ScreenView>
  )
}
